import { useQuery } from '@tanstack/react-query';

import {
  individualPausesService,
  FetchIndividualPausesResponse,
} from '@aslanpay/portal-common-lib';

const useFetchIndividualPauses = (individualIds: string[], enabled = true) => {
  return useQuery<FetchIndividualPausesResponse, Error>(
    ['fetchIndividualPauses', individualIds],
    () =>
      individualPausesService.fetchIndividualPauses({
        individualIds,
        page: 0,
        size: 999999,
        sortBy: 'pausedAt',
        sort: 'DESC',
      }),
    { enabled }
  );
};

export default useFetchIndividualPauses;
